/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "30e58d84d8da9734905e87ddc29c8f4a83835167";
